import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Descriptions, Row, Skeleton } from 'antd';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';
import IntlMessages from '../../../../layout/components/lang/IntlMessages';
import urlPageTemplateDetails from '../../../../urls/urlPageTemplateDetails';
import { EMPTY_IMAGE_PLACEHOLDER, EMPTY_VALUE_PLACEHOLDER } from '../../../../const/system';
import useCheckMobileScreen from '../../../../app/hooks/useCheckMobileScreen';
import PublishedTag from '../../../../components/PublishedTag';
import TemplateCollapsibleCards from '../../../../components/TemplateCollapsibleCards';
import { HasRights } from '../../../../components/HasRights/HasRights';
import { Permissions } from '../../../../const/permissions';



const NotificationDetailsCard = ({
  data,
  title = '',
  isLoadingCard,
  isFetching,
  dictionary,
  languages,
  templateCardsData,
  isLocalNotification = false,
}) => {
  const isMobile = useCheckMobileScreen(600);
  const canViewTemplate = HasRights([ Permissions.CONSTRUCTORS.TEMPLATES.FIND ]);

  return (
    <Card
      loading={isLoadingCard}
      className="hp-border-color-black-40 hp-card-6"
      title={data?.title}
    >
      {isFetching ? (
        <Row gutter={16}>
          {!isLocalNotification && (
            <Col span={4}>
              <Skeleton.Image active />
            </Col>
          )}
          <Col span={20}>
            <Skeleton active />
          </Col>
        </Row>
      ) : (
        <Row gutter={[ 24, 24 ]}>
          {!isLocalNotification && (
            <Col sm={24} md={6}>
              <img
                alt="preview"
                className="hp-mb-24"
                src={data?.preview ?? EMPTY_IMAGE_PLACEHOLDER}
              />
            </Col>
          )}

          <Col sm={24} md={18}>
            <Descriptions
              title={title}
              layout={isMobile ? 'vertical' : 'horizontal'}
              bordered
              className="hp-mb-32"
              column={1}
            >
              <Descriptions.Item label="ID" className='width-20-vw'>
                <span style={{ wordBreak: 'keep-all' }}>{data?.id}</span>
              </Descriptions.Item>
              <Descriptions.Item label={<IntlMessages id="ui-general-title" />}>
                {data?.title ?? EMPTY_VALUE_PLACEHOLDER}
              </Descriptions.Item>

              <Descriptions.Item label={<IntlMessages id="ui-general-template" />}>
                {!isEmpty(data?.template?.data?.title) ? (
                  <div>
                    {canViewTemplate ? (
                      <Link to={urlPageTemplateDetails({ templateId: data?.template?.data?.id })} target="_blank">
                        {data?.template?.data?.title}
                      </Link>
                    ) : (
                      <div>{data?.template?.data?.title}</div>
                    )}
                  </div>
                ) : EMPTY_VALUE_PLACEHOLDER}
              </Descriptions.Item>

              {isLocalNotification && (
                <Descriptions.Item label={<IntlMessages id="ui-general-published" />}>
                  <PublishedTag
                    published={data?.is_published}
                    publishedDate={data?.published_at}
                  />
                </Descriptions.Item>
              )}
            </Descriptions>

            <TemplateCollapsibleCards
              dictionary={dictionary}
              languages={languages}
              data={templateCardsData}
            />
          </Col>
        </Row>
      )}
    </Card>
  );
};


NotificationDetailsCard.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.number,
    preview: PropTypes.string,
    template: PropTypes.object,
    is_published: PropTypes.bool,
    published_at: PropTypes.string,
  }).isRequired,
  title: PropTypes.string.isRequired,
  isLoadingCard: PropTypes.bool,
  isLocalNotification: PropTypes.bool,
  isFetching: PropTypes.bool,
  dictionary: PropTypes.object,
  templateCardsData: PropTypes.object,
  languages: PropTypes.array,
};

export default NotificationDetailsCard;
